import type { FieldErrorDisplayKey } from './FieldErrorDisplayKey'
import type { FieldErrorPresenter } from './FieldErrorPresenter'
import { presentFieldIssueParams } from './presentFieldIssueParams'

/** A presenter whose key does not depend on the params. */
export const plainFieldErrorPresenter =
  (key: FieldErrorDisplayKey): FieldErrorPresenter =>
  (params, t) => ({ key, values: presentFieldIssueParams(params, t) })
